import { render, staticRenderFns } from "./Attachments144.vue?vue&type=template&id=91b3d936&scoped=true"
import script from "./Attachments144.vue?vue&type=script&lang=js"
export * from "./Attachments144.vue?vue&type=script&lang=js"
import style0 from "./Attachments144.vue?vue&type=style&index=0&id=91b3d936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b3d936",
  null
  
)

export default component.exports